"use client";

import React, { FC } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useFeatureDisabled } from "@/modules/feature-flag";
import { FeatureFlag } from "@/services/swagger/gen/models";
import { HomeLineGradiantIcon, HomeLineIcon, ProfileGradiantIcon, ProfileIcon, SwitchVerticalGradiantIcon, SwitchVerticalIcon, WalletGradiantIcon, WalletIcon } from "../components/icons";
import { GOLD18_IRT_SYMBOL } from "../constants";
import { cn } from "../utils";
import { createDashboardLink, createGoldOtcLink } from "../utils/createLink";
const BottomNav: FC = () => {
  const pathname = usePathname();
  const pathnameSplited = pathname.split("/").slice(1);
  const isInDashboardPage = pathnameSplited.length === 1;
  const isInOtcPage = pathnameSplited.includes("sell") || pathnameSplited.includes("buy");
  const isInAssetsPage = pathnameSplited.includes("assets");
  const isInProfilePage = pathnameSplited.includes("profile");
  const isBuyFeatureDisabled = useFeatureDisabled(FeatureFlag.BUY);
  return <div className="flex w-full items-center justify-around bg-white" data-sentry-component="BottomNav" data-sentry-source-file="bottom-nav.tsx">
      <Link href={createDashboardLink()} className="flex flex-col items-center justify-center gap-1" data-sentry-element="Link" data-sentry-source-file="bottom-nav.tsx">
        <div className={cn("flex h-8 w-14 items-center justify-center rounded-4xl ", {
        "bg-primary-100": isInDashboardPage
      })}>
          {isInDashboardPage ? <HomeLineGradiantIcon /> : <HomeLineIcon />}
        </div>
        <p className="text-2xs font-medium text-gray-900">خانه</p>
      </Link>
      <Link href={isBuyFeatureDisabled ? `/dashboard/${GOLD18_IRT_SYMBOL}/sell` : createGoldOtcLink()} className="flex flex-col items-center justify-center gap-1" data-sentry-element="Link" data-sentry-source-file="bottom-nav.tsx">
        <div className={cn("flex h-8 w-14 items-center justify-center rounded-4xl ", {
        "bg-primary-100": isInOtcPage
      })}>
          {isInOtcPage ? <SwitchVerticalGradiantIcon /> : <SwitchVerticalIcon />}
        </div>
        <p className="text-2xs font-medium text-gray-900">
          {isBuyFeatureDisabled ? "فروش طلا" : "خریدوفروش طلا"}
        </p>
      </Link>
      <Link href="/dashboard/assets" className="flex flex-col items-center justify-center gap-1" data-sentry-element="Link" data-sentry-source-file="bottom-nav.tsx">
        <div className={cn("flex h-8 w-14 items-center justify-center rounded-4xl ", {
        "bg-primary-100": isInAssetsPage
      })}>
          {isInAssetsPage ? <WalletGradiantIcon /> : <WalletIcon className="*:stroke-gray-500" />}
        </div>
        <p className="text-2xs font-medium text-gray-900">دارایی</p>
      </Link>
      <Link href="/dashboard/profile" className="flex flex-col items-center justify-center gap-1" data-sentry-element="Link" data-sentry-source-file="bottom-nav.tsx">
        <div className={cn("flex h-8 w-14 items-center justify-center rounded-4xl ", {
        "bg-primary-100": isInProfilePage
      })}>
          {isInProfilePage ? <ProfileGradiantIcon /> : <ProfileIcon />}
        </div>

        <p className="text-2xs font-medium text-gray-900">حساب کاربری</p>
      </Link>
    </div>;
};
export default BottomNav;